// extracted by mini-css-extract-plugin
export default {"success-modal":"successModal_success-modal__LU70R","success-modal__icon":"successModal_success-modal__icon__QU8Ff"};